export const isDefined = (value: any) => value !== null && value !== undefined;

export const isNonEmptyString = (value?: string | null | number) =>
  isDefined(value) && value !== "";
